<template>
  <div class="basic-block block-lead-menu" :style="styles">
    <div class="more-info-box">
      <img src="/static/img/recommend/lp/touwa/more_info.svg" class="more-info" alt="">
     
      
   </div>
    <div class="content-wrap">
      <div class="block-lead-menu__inner">
        <div class="block-lead-menu__counselor">
          <img class="block-lead-menu__counselor-image" :src="targetInfo.leadMenu.counselorImage" alt="">
          <p class="block-lead-menu__comment">属性開抛が持つ３つの要素を、ひとつずつ説明していきますね。</p>
        </div>
        <p class="block-lead-menu__lead" v-html="targetInfo.leadMenu.lead"></p>
        
        <!-- <lp-base-button label="もっと占ってみる" design="fill" :color-scheme="colorScheme" class="block-lead-menu__btn" @clicked="clicked" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'

export default {
  name: 'BlockLeadMenu',
  components: {
    LpBaseButton,
  },
  props: {
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    subscUrl: String,
    lpId: Number,
  },
  computed:{
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    }
  },
  methods: {
    clicked() {
      location.href = this.subscUrl
    },
    toInput() {
      const payload = {
        link: `/recommend/lp/${this.lpId}/basic/input`,
        param: {
          'event_category': `LP${this.lpId}basicresult-free-shindan-button`,
          // 'event_label': ''
        }
      }
      this.$emit('link', payload)
    },
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.block-lead-menu {
  background: #fff;
  padding: 24px 0;
  padding-top:0 ;
  &__deco {
    position: absolute;
    top: -27px;
    left: 0;
    width: 17.6%;
    max-width: 80px;
    z-index: 2;
  }
  &__inner {
    padding: 0 20px;
  }
  &__counselor {
    display: flex;
    align-items: center;
  }
  &__counselor-image {
    flex: 0 1 auto;
    width: 38.3%;
    max-width: 140px;
    margin: 0 10px 0 0;
  }
  &__comment {
    flex: 1 1 auto;
    font-size: 15px;
    line-height: 22px;
    font-weight: bold;
    font-feature-settings: "palt";
    letter-spacing: 1px;
    text-align: justify;
    background: $l_col_second;
    border-radius: 8px;
    padding: 18px 10px;
    margin: 0;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      right: calc(100% - 1px);
      margin: auto;
      width: 0;
      height: 0;
      border: 10px solid transparent;
      border-right-color: $l_col_second;
    }
    b {
      font-size: 16px;
    }
  }
  &__lead {
    font-weight: bold;
    font-size: 16px;
    line-height: 28px;
    text-align: center;
    letter-spacing: 1px;
    color: $l_col_keycolor;
    margin: 0 auto;
  }
  &__btn {
    max-width: 270px;
    margin: 0 auto;
  }
  &__link {
    margin: 16px 0 0;
    display: block;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    color: $l_col_second;
    text-align: right;
  }
  .more-info-box {
    background: #f0ebe0;
    text-align: center;
    position: relative;
    height: 20px;
    width: 100%;
    margin-bottom: 67px;
    &:after{
      content: '';
      position: absolute;
      width: 100%;
      height: 0;
      bottom: -61px;
      left: 0;
      border-left: 50vw solid transparent;
      border-right: 50vw solid transparent;
      border-top: 61px solid #f0ebe0;
      z-index: -1;
      @include mq('w580'){
        border-left: 290px solid transparent;
        border-right: 290px solid transparent;
      }
    }
  }

  .more-info {
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translate(-50%, -50%);
}



}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/touwa/blocks/BlockLeadMenu2.vue